import './../assets/css/style.css';
import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css' ;
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { ImgBanner } from "./banner";
import { BoxTitle } from "./box";
import { Section } from "./section";
import { TitleMarca } from "./Text";

import BannerDesk from "./../img/2025/cyber/bannerBottom/suplementos.png";
import BannerMob from "./../img/2025/cyber/bannerBottom/suplementosMob.png";
import BannerBottom1 from './../img/2025/cyber/ofertas/1.png';
import BannerBottom2 from './../img/2025/cyber/ofertas/2.png';
import BannerBottom3 from './../img/2025/cyber/ofertas/3.png';
import BannerBottom4 from './../img/2025/cyber/ofertas/4.png';

function BannerBottomCyber() {
    const bannersbottom = {
        dots: true,
        arrows: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: true,
        responsive: [
          { breakpoint: 600,  settings: { slidesToShow: 1, slidesToScroll: 1 } },
          { breakpoint: 767,  settings: { slidesToShow: 2, slidesToScroll: 1 } },
          { breakpoint: 1024, settings: { slidesToShow: 4, slidesToScroll: 1 } }
        ],
    }
    /* const BannerFull = 'https://blackfriday.futfanatics.com.br/img/banner/bannerscyber/banner-middle-desk.png';
    const BannerFullMob = 'https://blackfriday.futfanatics.com.br/img/banner/bannerscyber/banner-middle_mobile.png';
    const BannerBottom1 = 'https://blackfriday.futfanatics.com.br/img/banner/bannerscyber/trio-bottom_cyber.png';
    const BannerBottom2 = 'https://blackfriday.futfanatics.com.br/img/banner/bannerscyber/trio-bottom_cyber2.png';
    const BannerBottom3 = 'https://blackfriday.futfanatics.com.br/img/banner/bannerscyber/trio-bottom_cyber3.png'; */

        return(
            <>
                <div className='box-banner-full'>
                    <a href='https://www.futfanatics.com.br/suplementos'>
                        <img className='banner-full d-md-block d-none' src={BannerDesk}/>
                        <img className='banner-full d-md-none' src={BannerMob}/>   
                    </a>
                    
                </div>
                <div className='container mt-3'>
                    <Slider {...bannersbottom} className='slick-banners_bottom'>
                        <div className='item'>
                            <a href='https://www.futfanatics.com.br/bone?order=1'>
                                <img className='bannersBottom' src={BannerBottom1}/>
                            </a>
                        </div>
                        <div className='item'>
                            <a href='https://www.futfanatics.com.br/clubes-brasileiros?loja=311840&categoria=11&range=&variacao=camisa-oficial_sim&order=4'>
                                <img className='bannersBottom' src={BannerBottom2}/>
                            </a>
                        </div>
                        <div className='item'>
                            <a href='https://www.futfanatics.com.br/casual?&order=3'>
                                <img className='bannersBottom' src={BannerBottom3}/>
                            </a>
                        </div>
                        <div className='item'>
                            <a href='https://www.futfanatics.com.br/futebol/chuteiras?order=1'>
                                <img className='bannersBottom' src={BannerBottom4}/>
                            </a>
                        </div>
                    </Slider>
                </div>
          
            </>
        )
}

export default BannerBottomCyber;